import { render, staticRenderFns } from "./SurveyCreate.vue?vue&type=template&id=1bd7f9df&scoped=true"
import script from "./SurveyCreate.vue?vue&type=script&lang=js"
export * from "./SurveyCreate.vue?vue&type=script&lang=js"
import style0 from "./SurveyCreate.vue?vue&type=style&index=0&id=1bd7f9df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7f9df",
  null
  
)

export default component.exports